import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9d073a76"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "info"
};
const _hoisted_3 = {
  class: "details"
};
const _hoisted_4 = {
  class: "block-and-state"
};
const _hoisted_5 = {
  class: "flag-count-and-ai-status"
};
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = {
  class: "name"
};
const _hoisted_8 = {
  class: "item-image"
};
const _hoisted_9 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_app_icon, {
    icon: "blocked",
    size: 20,
    color: $props.blockIconColor
  }, null, 8, ["color"]), _createElementVNode("div", {
    class: "state-icon-container",
    style: _normalizeStyle(`background: ${$options.getStateBackgroundColor()};`)
  }, [(_openBlock(), _createBlock(_resolveDynamicComponent($options.getStateIcon()), {
    height: 20,
    width: 20,
    style: _normalizeStyle(`background: ${$props.state === 'inconsistent' ? '#D7AA0F' : 'inherit'}; border-radius: 13.75px;`)
  }, null, 8, ["style"]))], 4)]), _createElementVNode("div", _hoisted_5, [$props.item.flag ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $props.item.flag,
    class: "flag",
    alt: $props.item.countryCode
  }, null, 8, _hoisted_6)) : _createCommentVNode("", true), _createVNode(_component_app_icon, {
    icon: "sub",
    size: 16
  }), _createTextVNode(" " + _toDisplayString($props.item.subDetails) + " ", 1), !!$props.ai_status ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(["ai-status", {
      [$props.item.result]: !!$props.item.result
    }])
  }, [_createVNode(_component_app_icon, {
    icon: "ai",
    size: 13,
    color: $options.getAIStatusIconColor()
  }, null, 8, ["color"]), _createTextVNode(" " + _toDisplayString($props.ai_status), 1)], 2)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_7, _toDisplayString($props.item.name), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
    src: $props.item.image,
    class: "image",
    alt: $props.item.countryCode
  }, null, 8, _hoisted_9)])]);
}